// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3C-R_","errorLogs":"styles_errorLogs__14lUe"};